import React from "react";
import { useAppSelector } from "../../../../store/hooks/StoreHooks";
import useCollapseFacade from "../../../../facade/collapse.Facade";
import Accordion from "../../../common/accordion";
import { LABELS } from "../../../../constants/labels/help.labels";

const SurfaceEquipment: React.FC = () => {
  const { baseLineCollapse, wappertwoCollapse, wapperHarmonicFilterCollapse } = useAppSelector(
    (state) => state?.collapse
  );

  const { updateBaseLineCollapse, updateWappertwoCollapse, updateWapperHarmonicFilterCollapse } =
    useCollapseFacade();

  const handleCollapseChange = (key: boolean, name: string) => {
    if (name === "baseLine") updateBaseLineCollapse(key);
    else if (name === "wappertwo") updateWappertwoCollapse(key);
    else if (name === "wapperHarmonicFilter") updateWapperHarmonicFilterCollapse(key);

  };

  return (
    <>
      <div className='flex flex-col justify-center item-center w-full h-full gap-[16px]'>
        <Accordion
          title={LABELS?.surfaceEquipment}
          id={'baseLine'}
          isOpen={!baseLineCollapse}
          onToggle={() => handleCollapseChange(!baseLineCollapse, "baseLine")}
          content={
            <div className="flex justify-center items-center bg-darkcolor-800 p-[16px] w-full rounded-br-lg rounded-bl-lg">
              <div className='pad-all w-full bg-darkcolor-700 border-[1px] border-darkcolor-400 rounded-lg'>
                <table className='table-auto w-full  border-collapse text-left'>
                  <colgroup>
                    <col style={{ width: "10%" }} />
                    <col style={{ width: "40%", borderRight: "1px solid #4a5463" }} />
                    <col style={{ width: "10%" }} />
                    <col style={{ width: "40%" }} />
                  </colgroup>
                  <tr className="border-b-[1px] border-darkcolor-400 align-center text-[14px] font-normal">
                    <th className="col-1 px-[24px] py-[16px] font-normal">
                      KVA required @ (operating frequency) Hz
                    </th>
                    <td className='col-5 px-[24px] py-[16px]'>
                      <div className='secondary pb-4'>
                        {" "}
                        (3^0.5 * SurfaceVoltage * MotorPerformaceCurrent) / 1000
                      </div>
                      <div className='pb-4'>
                        <p className='secondary'>
                          MotorPerformaceCurrent :
                        </p>
                        <p className='secondary-text'>
                          current * NamePlatecurrent
                        </p>
                      </div>
                      <div className='pb-4'>
                        <p className='secondary'>NamePlatecurrent :</p>
                        <p className='secondary-text'>
                          Selected motor Current from ESP catalog (Dr_Motors
                          table in database)
                        </p>
                      </div>
                      <div className='pb-4'>
                        <p className='secondary'>current :</p>
                        <p className='secondary-text'>
                          C0 + C1 * PUHP + C2 * PUHP^2 + C3 * PUHP^3 + C4 *
                          PUHP^4 + C5 * PUHP^5
                        </p>
                      </div>
                      <div className='pb-4'>
                        <p className='secondary'>
                          [C0, C1, C2, C3, C4, C5] :
                        </p>
                        <p className='secondary-text'>
                          Selected motor coefficient from ESP catalog (Dr_Motors
                          table in database)
                        </p>
                      </div>
                      <div className='pb-4'>
                        <p className='secondary'>PUHP :</p>
                        <p className='secondary-text'>
                          (TotalBHP / motorHP)
                        </p>
                      </div>
                      <div className='pb-4'>
                        <p className='secondary'>motorHP :</p>
                        <p className='secondary-text'>
                          (size * Operatingfrequency / 60)
                        </p>
                      </div>
                      <div className='pb-4'>
                        <p className='secondary'> size :</p>
                        <p className='secondary-text'>
                          Selected motor size from ESP catalog (Dr_Motors table
                          in database)
                        </p>
                      </div>
                      <div className='pb-4'>
                        <p className='secondary'>TotalBHP :</p>
                        <p className='secondary-text'>
                          Total power required @ opearting frequency - motor tab
                        </p>
                      </div>
                      <div>
                        <p className='secondary'> SurfaceVoltage:</p>
                        <p className='secondary-text'>
                          Surface equipment tab
                        </p>
                      </div>
                    </td>
                    <th className="col-1 px-[24px] py-[16px] font-normal">Surface voltage</th>
                    <td colSpan={3} className='col-5 px-[24px] py-[16px]'>
                      <div className='secondary pb-4'>
                        VoltageMotor + VoltDrop
                      </div>
                      <div className='pb-4'>
                        <p className='secondary'>VoltDrop :</p>
                        <p className='secondary-text'>
                          Total cable volt loss @ design frequency from cable tab
                        </p>
                      </div>
                      <div className='pb-4'>
                        <p className='secondary'>VoltageMotor :</p>
                        <p className='secondary-text'>
                          (NamePlatevoltage * frequency/60)
                        </p>
                      </div>
                      <div className=''>
                        <p className='secondary'>NamePlatevoltage :</p>
                        <p className='secondary-text'>
                          Selected motor voltage from ESP catalog (Dr_Motors
                          table in database)
                        </p>
                      </div>
                    </td>
                  </tr>
                  <tr className="border-b-[1px] border-darkcolor-400 align-center text-[14px] font-normal">
                    <th className="col-1 px-[24px] py-[16px] font-normal">Basic electricity cost / 24Hr</th>
                    <td className='col-5 px-[24px] py-[16px]'>
                      <div className='secondary pb-4'>
                        (KVARequirement * PowerFactor * 24 * CostPerHour) /
                        Efficiency
                      </div>
                      <div className='pb-4'>
                        <p className='secondary'>KVARequirement :</p>
                        <p className='secondary-text'>
                          Surface equipment tab
                        </p>
                      </div>
                      <div className='pb-4'>
                        <p className='secondary'>PowerFactor :</p>
                        <p className='secondary-text'>
                          Surface equipment tab
                        </p>
                      </div>
                      <div className='pb-4'>
                        <p className='secondary'>CostPerHour :</p>
                        <p className='secondary-text'>
                          Cost of electricity / kWh from surface equipment tab
                        </p>
                      </div>
                      <div>
                        <p className='secondary'>Efficiency :</p>
                        <p className='secondary-text'>
                          Ideal assumption as 0.9 or mannualy overriden user
                          value
                        </p>
                      </div>
                    </td>
                    <th className="col-1 px-[24px] py-[16px] font-normal">
                      Drive Amps @ (operating frequency) Hz
                    </th>
                    <td className='col-5 px-[24px] py-[16px] p-2'>
                      <div className='secondary pb-4'>
                        (KVARequired@DesignFrequency * 1000) / (SupplyVoltage *
                        3^0.5)
                      </div>
                      <div className='pb-4'>
                        <p className='secondary'>
                          KVARequired@DesignFrequency :
                        </p>
                        <p className='secondary-text'>
                          Surface equipment tab
                        </p>
                      </div>
                      <div>
                        <p className='secondary'>SupplyVoltage :</p>
                        <p className='secondary-text'>
                          Surface equipment tab
                        </p>
                      </div>
                    </td>
                  </tr>
                  <tr className="align-center text-[14px] font-normal">
                    <th className="col-1 px-[24px] py-[16px] font-normal">
                      KW required @ (operating frequency) Hz
                    </th>
                    <td className='col-5 px-[24px] py-[16px]'>
                      <div className='secondary pb-4'>
                        KW<small>in</small> = KW<small>out</small> / Efficiency
                      </div>
                      <div className='pb-4'>
                        <p className='secondary'>Efficiency :</p>
                        <p className='secondary-text'>
                          Ideal assumption as 0.9 or mannualy overriden user
                          value
                        </p>
                      </div>
                      <div>
                        <p className='secondary'>
                          KW<small>out</small> :
                        </p>
                        <p className='secondary-text'>
                          Selected motor's power output calculated at a required
                          frequency and calculated as KW<small>out</small> = V
                          <small>d</small> * I<small>d</small> * PF
                          <small>d</small> *<span>&#8730;</span>3 / 1000
                        </p>
                      </div>
                    </td>
                    <th className="col-1  px-[24px] py-[16px] font-normal"></th>
                    <td colSpan={3} className='col-5'></td>
                  </tr>
                </table>
              </div>
            </div>
          }
        />
        <Accordion
          title={LABELS?.controller}
          id={'wappertwo'}
          isOpen={!wappertwoCollapse}
          onToggle={() =>
            handleCollapseChange(!wappertwoCollapse, "wappertwo")
          }
          content={
            <div className="flex justify-center items-center bg-darkcolor-800 p-[16px] w-full rounded-br-lg rounded-bl-lg">
              <div className='pad-all w-full bg-darkcolor-700 border-[1px] border-darkcolor-400 rounded-lg'>
                <table className='w-full w-full table table-striped table-bordered dtr-inline'>
                  <colgroup>
                    <col style={{ width: "50%", borderRight: "1px solid #4a5463" }} />
                    <col style={{ width: "50%" }} />
                  </colgroup>
                  <tr className="align-center text-[14px] font-normal">
                    <th className='col-2 px-[24px] py-[16px] font-normal'>Percentage of controller load </th>
                    <td className='col-8 px-[24px] py-[16px]'>
                      <div className='secondary pb-4'>
                        If SwitchBoard is selected
                        <br />
                        (SurfaceVoltage/ SwitchBoardVolt) * 100
                      </div>
                      <div className='pb-4'>
                        <p className='secondary'>SurfaceVoltage :</p>
                        <p className='secondary-text'>
                          Surface equipment tab
                        </p>
                      </div>
                      <div className='pb-4'>
                        <p className='secondary'>SwitchBoardVolt :</p>
                        <p className='secondary-text'>
                          Selected switch board voltage
                        </p>
                      </div>
                      <div className='secondary'>
                        If VSD is selected
                        <br />
                        (KVARequired@DesignFrequency / VSDPower) * 100
                      </div>
                      <div className='pb-4'>
                        <p className='secondary'>
                          KVARequired@DesignFrequency :
                        </p>
                        <p className='secondary-text'>
                          Surface equipment tab
                        </p>
                      </div>
                      <div>
                        <p className='secondary'>VSDPower :</p>
                        <p className='secondary-text'>
                          Selected VSD power
                        </p>
                      </div>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          }
        />
        <Accordion
          title={LABELS?.harmonicFilter}
          id={'wapperHarmonicFilter'}
          isOpen={!wapperHarmonicFilterCollapse}
          onToggle={() =>
            handleCollapseChange(!wapperHarmonicFilterCollapse, "wapperHarmonicFilter")
          }
          content={
            <div className="flex justify-center items-center bg-darkcolor-800 p-[16px] w-full rounded-br-lg rounded-bl-lg">
              <div className='pad-all w-full bg-darkcolor-700 border-[1px] border-darkcolor-400 rounded-lg'>
                <table className='table-auto w-full border-collapse text-left'>
                  <colgroup>
                    <col style={{ width: "10%" }} />
                    <col style={{ width: "40%", borderRight: "1px solid #4a5463" }} />
                    <col style={{ width: "10%" }} />
                    <col style={{ width: "40%" }} />
                  </colgroup>
                  <tr className="border-b-[1px] border-darkcolor-400 align-center text-[14px] font-normal">
                    <th className="col-1 px-[24px] py-[16px] font-normal">VSD Working Amps</th>
                    <td className='col-5 px-[24px] py-[16px] px-[24px] py-[16px]'>
                      <div className='secondary'>
                        Input VSD amps (Drive Amps value from surface equipment
                        tab)
                      </div>
                    </td>
                    <th className="col-1 px-[24px] py-[16px] font-normal">Avg current trend</th>
                    <td className='col-5 px-[24px] py-[16px]  align-left p-2'>
                      <div className='secondary'>
                        Input VSD amps / 1.4 * T_Avrg_Amps
                      </div>
                    </td>
                  </tr>
                  <tr className="align-center text-[14px] font-normal">
                    <th className="col-1 px-[24px] py-[16px] font-normal">Filter loading (%)</th>
                    <td className='col-5 px-[24px] py-[16px] px-[24px] py-[16px]'>
                      <div className='secondary'>
                        100 * (Avg current trend / VSD working Amps)
                      </div>
                    </td>
                    <th className="col-1 px-[24px] py-[16px] font-normal">Re-Run Amps</th>
                    <td className='col-5 px-[24px] py-[16px]  align-left p-2'>
                      <div className='secondary'>1.4 * T_Avrg_Amps</div>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          }
        />
      </div>
    </>
  );
};

export default SurfaceEquipment;
